import React from 'react'
import { contentHelper, parseSmarty } from '../../shared/_layouts/_templates/_includes/parseSmarty.jsx'
import Tracker from '../../_plugins/lib/tracker'
import ReduxStores from '../../shared/stores/connects'
import FeedbackSection from './_includes/components/feedbackSection'
import Helpers from '../../_plugins/lib/helpers'
import { object } from 'prop-types'

class LandingPages extends React.Component {
  constructor (props) {
    super(props)

    if (props.agentSetup) props.agentSetup()
    if (props.initialSetup) props.initialSetup()
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.agentData.agent && this.props.agentData.agent) {
      this.initialLoad(this.props)
    }
  }

  initialLoad (props) {
    const { agentData, pageData: { html }, settings } = props
    const setVar = Helpers.getSmartyVariables(html)

    if (setVar.agent) {
      agentData.agent = setVar.agent
      if (props.updateAgent) props.updateAgent(agentData.agent)
    } else {
      if (props.setupAgent) props.setupAgent()
    }

    let environment = settings.env
    if (Helpers.getParameterByName('data-pipeline-staging')) environment = 'staging'
    if (Helpers.getParameterByName('data-pipeline-production')) environment = 'production'

    Tracker.init({
      agent: agentData.agent,
      environment,
      templateGroup: 'heha-travel',
      schemaVersions: {
        auto_capture: 'v4.3.2',
        capture: 'v4.3.2',
        click: 'v4.4.1',
        load: 'v3.5.1',
        trip_intent: 'v2.1.1'
      },
      lb: settings.orionLb
    })

    window.universalJavascriptLoaded = true
    if (props.userLogin) props.userLogin()
    contentHelper.attachEvents()
    contentHelper.appendJsContent(html)
  }

  render () {
    const { agentData, domainSettings, formSettings, settings, pageData } = this.props
    let { html } = pageData
    contentHelper.appendJsSrc(html)
    const setVar = Helpers.getSmartyVariables(html)
    html = html.replace(contentHelper.regexScriptSrc, '')
    html = html.replace(contentHelper.regexScriptContent, '')
    html = parseSmarty(html, {
      domainSettings,
      formSettings,
      settings,
      agentData,
      pageData,
      setVar,
      location: '',
      noSchemaMarkup: true
    })
    return [
      <nav key='navbar' className='mb-0 navbar navbar-default' />,
      <div key='content' className='bg-brand py-5 container'>
        <div id='ContentArea' dangerouslySetInnerHTML={{ __html: html }} />
      </div>,
      <div key='feedback' className='bg-primary text-center'>
        <FeedbackSection />
      </div>
    ]
  }
}

LandingPages.propTypes = {
  domainSettings: object,
  settings: object,
  pageData: object.isRequired,
  agents: object
}

export default ReduxStores(LandingPages, ['agents', 'login'])



// WEBPACK FOOTER //
// ./_layouts/_templates/landingPages.jsx